import { useNavigate } from "react-router-dom";
import { ArrowRight, Tag } from "lucide-react";
import api from "@/lib/api";
import { headlineFigure, promoBadge, scopeLabel } from "@/lib/promotions";

export const FeaturedTextPromotions = ({ promotions = [] }) => {
  const navigate = useNavigate();
  const offers = promotions
    .filter((promotion) => promotion.display_format !== "banner")
    .slice(0, 3);

  if (!offers.length) {
    return null;
  }

  const openOffer = (offer) => {
    api.post(`/promotions/${offer.id}/click`).catch(() => {});
    navigate("/specials");
  };

  return (
    <section
      className="border-b border-slate-200 py-7 dark:border-slate-800"
      data-testid="inventory-text-specials"
    >
      <div className="mb-4 flex items-end justify-between gap-4">
        <div>
          <p className="font-mono text-xs font-bold uppercase tracking-[0.18em] text-rose-600">
            Live offers
          </p>
          <h2
            className="mt-1 font-display text-2xl font-black uppercase text-slate-950 dark:text-white"
          >
            More ways to save
          </h2>
        </div>
        <button
          type="button"
          onClick={() => navigate("/specials")}
          className={
            "inline-flex shrink-0 items-center gap-1 text-sm font-bold " +
            "text-rose-600 hover:text-rose-700"
          }
          data-testid="inventory-all-specials"
        >
          All specials <ArrowRight className="h-4 w-4" />
        </button>
      </div>
      <div className="grid gap-3 md:grid-cols-3">
        {offers.map((offer) => (
          <button
            type="button"
            key={offer.id}
            onClick={() => openOffer(offer)}
            className={
              "group border border-slate-200 bg-white p-4 text-left " +
              "transition-[border-color,transform,box-shadow] duration-200 " +
              "hover:-translate-y-0.5 hover:border-rose-400 hover:shadow-lg " +
              "dark:border-slate-800 dark:bg-slate-900"
            }
            data-testid={`inventory-text-special-${offer.id}`}
          >
            <span
              className="inline-flex items-center gap-1 text-xs font-bold uppercase tracking-wide text-rose-600"
            >
              <Tag className="h-3.5 w-3.5" /> {promoBadge(offer)}
            </span>
            <p className="mt-3 font-display text-xl font-black text-slate-950 dark:text-white">
              {headlineFigure(offer) || offer.title}
            </p>
            {headlineFigure(offer) && (
              <p className="mt-1 truncate text-sm font-semibold text-slate-600 dark:text-slate-300">
                {offer.title}
              </p>
            )}
            {scopeLabel(offer) && (
              <p className="mt-2 text-xs font-semibold text-slate-400 dark:text-slate-500">
                {scopeLabel(offer)}
              </p>
            )}
          </button>
        ))}
      </div>
    </section>
  );
};